import { OrganizationInfo, OrganizationInfoExpanded } from "services/organization";
import { Button, EllipsisVerticalIcon, Grid, Popover } from "@wexinc/wex-ui";
import React from "react";
import { Link } from "react-router-dom";
import { Cell, Column } from "react-table";

interface Props {
  globalFilter: string | undefined;
  organizations: OrganizationInfoExpanded[];
  onAction: OnOrganizationAction;
  selectedOrganizationId?: string;
}

const OrganizationsGrid: React.FC<Props> = (props) => {
  const { organizations, globalFilter, selectedOrganizationId } = props;
  const columns = React.useMemo(() => getColumns(props.onAction), [props.onAction]) as Array<
    Column<OrganizationInfoExpanded>
  >;

  // leaving this as a deprecated Grid for now because the organizations array is being managed in a complex way
  return (
    <Grid<OrganizationInfoExpanded>
      pagination="client-side"
      memoizedColumns={columns}
      data={organizations}
      globalFilter={globalFilter}
      selectedRowIds={selectedOrganizationId ? [selectedOrganizationId] : undefined}
      defaultSort={"name"}
    />
  );
};

export default OrganizationsGrid;

function getColumns(onAction: OnOrganizationAction) {
  return [
    {
      Header: "ORGANIZATION",
      accessor: "name",
      Cell: ({ row }: Cell<OrganizationInfoExpanded>) => {
        return (
          <Link
            to={row.original.id}
            className="text-sm text-primary-40"
          >
            {row.original.name}
          </Link>
        );
      },
    },
    {
      Header: "SUB-ORGS",
      accessor: "subOrgCount",
    },
    {
      Header: "MEMBERS",
      accessor: "memberCount",
    },
    {
      Header: "DESCRIPTION",
      accessor: "description",
      Cell: ({ row }: Cell<OrganizationInfoExpanded>) => {
        return (
          <div
            className="overflow-hidden line-clamp-1"
            data-tip={row.original.description}
          >
            {row.original.description}
          </div>
        );
      },
    },
    {
      id: "view-details",
      Cell: ({ row }: Cell<OrganizationInfoExpanded>) => {
        return (
          <ActionsMenu
            organization={row.original}
            onAction={onAction}
          />
        );
      },
      width: "80px",
    },
  ];
}

export type OnOrganizationAction = (organization: OrganizationInfo) => void;

export type OrganizationActions = "editOrg";

interface ActionsMenuProps {
  organization: OrganizationInfo;
  onAction: OnOrganizationAction;
}

const ActionsMenu: React.FC<ActionsMenuProps> = (props) => {
  const handleEditOrganization = React.useCallback(() => {
    props.onAction(props.organization);
  }, []);
  return (
    <Popover
      testId="show-metric-actions-menu"
      className="w-34 p-2"
      anchorButtonClassName="w-8 h-8 flex items-center"
      getAnchorContent={() => (
        <div>
          <EllipsisVerticalIcon />
        </div>
      )}
    >
      {() => (
        <Button
          testId="edit-organization"
          buttonType="secondary-neutral"
          className="w-full !justify-start"
          onClick={handleEditOrganization}
        >
          Edit Organization
        </Button>
      )}
    </Popover>
  );
};
